import React from 'react';
// @ts-ignore
import styles from './overlay.module.scss';

export function SpinnerOverlay() {
  return (
    <div className={styles.spinnerContainer}>
      <div className={styles.spinner}>
        <div className="k-loading-image" />
      </div>
    </div>
  );
}
